import React, { Fragment, useState } from 'react';
//import history from '../../../';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Modal from '../../../../shared/components/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import { useEffect } from 'react';

const ReactTableActionsRetentionType = ({ data, refresh, onEditRetentionType }) => {

    const [isDelete, setIsdeleted] = useState(false);

    useEffect(() => {
        console.log("DATACOM", data)
    })

    const onDelet = () => {
        setIsdeleted(false);
        //setIsLoading(true);
        let dataSend = { id_tipo_retencion: data.data.original.id_tipo_retencion };
        console.log(dataSend);
        return new Promise((resolve, reject) => {
            fetch(process.env.REACT_APP_PUBLIC_URL + 'tipo-retencion/delete', {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    console.log(response);
                    refresh();
                    return response.text();
                })
                .then(data => {
                    resolve(true);
                })
                .catch((error) => {
                    resolve(error);
                });
        })
    }

    const onToggleUpdateRetention = (retention) => {
        onEditRetentionType(retention);
    }

    return (<Fragment>
        <td role="cell">

            <Tooltip title="Editar">
                <IconButton aria-label="edit" onClick={() => {
                    onToggleUpdateRetention(data.data.original)
                }}>
                    <EditOutlinedIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title="">
                <IconButton aria-label="delete" onClick={() => {
                    setIsdeleted(true);
                }}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip>
            {isDelete ?
                <Modal
                    color={'warning'}
                    title={"Seguro"}
                    message={"¿Deseas eliminar este Gasto?"}
                    modal={isDelete}
                    onOk={onDelet}
                    toggle={() => { setIsdeleted(!isDelete) }}
                />
                : null}
        </td>
    </Fragment>)
}

export default ReactTableActionsRetentionType;